import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@app/Shared/modules/material.modules';
import { ActionRowComponent } from './action-row/action-row.component';
import { ActionDialogComponent } from './action-dialogs/action-dialog/action-dialog.component';
import { ChildActionDialogComponent } from './action-dialogs/child-action-dialog/child-action-dialog.component';

@NgModule({
  declarations: [
    ActionRowComponent,
    ActionDialogComponent,
    ChildActionDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule
  ],
  exports: [
    ActionRowComponent,
    ActionDialogComponent,
    ChildActionDialogComponent
  ]
})
export class ActionComponentsModule { }
